<template>
  <div class="container">
    <van-search
      v-model="value"
      @search="onSearch"
      placeholder="请输入搜索关键词"
    />
    <div class="doctor-list" @scroll="handleScroll">
      <div class="doctor-item" v-for="(docItem, index) in list" :key="index">
        <div class="doctor-box">
          <div class="card-item">
            <div class="head-box">
              <img :src="getImg(docItem.avatar)" />
            </div>
            <div class="head-name-detail">
              <div class="detail-item">
                <span class="name">{{ docItem.doctorName }}</span>
              </div>
              <div class="detail-item">科室名称：{{ docItem.deptName }}</div>
            </div>
          </div>
          <div class="do" @click="toDoctorDetail(docItem)">
            医生主页<van-icon name="arrow" />
          </div>
        </div>
      </div>
      <van-empty
        v-if="list == ''"
        class="custom-image"
        image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        description="暂无数据"
      />
    </div>
  </div>
</template>

<script>
import { getBaseUrl } from '../../utils/request'
import { docList } from '@/api/api'
export default {
  name: 'selectDoctor',
  data() {
    return {
      list: [],
      value: '',
      newData: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getDocList()
  },
  mounted() {},
  methods: {
    getDocList() {
      docList(this.newData).then(res => {
        if (res.code == 200) {
          this.list = [...this.list, ...res.rows]
        }
      })
    },
    getImg(url) {
      if (url) return getBaseUrl() + url
      else return require('@/assets/head.jpg')
    },
    onSearch() {
      this.newData.pageNum += 1
      this.newData.pageSize += 10
      this.newData.doctorName = this.value
      this.list = []
      this.getDocList()
    },
    // 查看医生主页
    toDoctorDetail(code) {
      this.$router.push({
        name: 'doctorDetail',
        query: {
          status: 'docindex',
          docCode: JSON.stringify(code)
        }
      })
    },
    // 触底加载更多
    handleScroll(event) {
      console.log(event)

      const bottomOfWindow =
        Math.ceil(event.target.scrollTop + event.target.clientHeight) >=
        event.target.scrollHeight
      if (bottomOfWindow) {
        this.newData.pageNum += 1
        this.newData.pageSize += 10
        this.getDocList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
}
.dept-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  padding: 0 10px;
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
.week-box {
  width: 100%;
  overflow-x: auto;
  height: 70px;
  border-bottom: 1px solid #ebedf0;
  display: flex;
}
.week-item {
  width: 14vw;
  min-width: 14vw;
  font-size: 12px;
  text-align: center;
  .select-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .wk-item-day {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      width: 25px;
      border-radius: 12.5px;
      margin-top: 10px;
      &-active {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        width: 25px;
        border-radius: 12.5px;
        margin-top: 10px;
        background-color: #3478f7;
        color: #fff;
      }
    }
  }
  .wk-item-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 3px;
  }
  .color-blue {
    color: #3478f7;
  }
  .color-red {
    color: red;
  }
}
.doctor-list {
  overflow: scroll;
  height: 100vh;
  max-height: 100vh;
  width: 100vw;
  padding: 10px;
  .doctor-item {
    width: 100%;
    background: #fff;
    box-shadow: 3px 0 9px #ebedf0;
    padding: 10px 10px 0px 10px;
    font-size: 13px;
    margin-bottom: 10px;
    .doctor-box {
      width: 100%;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-item {
        width: 70%;
        height: 55px;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        .head-box {
          width: 40px;
          height: 40px;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
          }
        }
        .head-name-detail {
          width: calc(100% - 50px);
          .detail-item {
            width: 100%;
            height: 22.5px;
            display: flex;
            align-items: flex-end;
            padding-left: 10px;
            color: #666;
            font-size: 12px;
            .name {
              font-size: 15px;
              padding-right: 10px;
              color: #000;
            }
            .status {
              padding: 2px 5px;
              color: #fff;
              border-radius: 3px;
              margin-left: 10px;
            }
            .color-blue {
              background: #3478f7;
            }
            .color-red {
              background: red;
            }
          }
        }
      }
      .do {
        width: 30%;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #3478f7;
      }
    }
    .doctor-num {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 5px 0px 8px 10px;
      justify-content: space-between;
      .bet {
        display: flex;
        align-items: center;
        .much {
          font-size: 12px;
          color: rgb(237, 125, 84);
          padding-right: 10px;
        }
      }
    }
  }
}
</style>
